import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { WizardStep } from './WizardStep';

@Injectable({
  providedIn: 'root',
})
export class WizardService {
  private stepChangeSubject: BehaviorSubject<WizardStep> =
    new BehaviorSubject<WizardStep>(null);

  // tslint:disable-next-line:variable-name
  private _disableNextButton: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  constructor() {}

  nextButtonDisabled(): Observable<boolean> {
    return this._disableNextButton.asObservable();
  }

  disableNextButton(): void {
    this._disableNextButton.next(true);
  }

  enableNextButton(): void {
    this._disableNextButton.next(false);
  }

  setNextButtonState(state: boolean): void {
    this._disableNextButton.next(!state);
  }

  stepChanged(): Observable<WizardStep> {
    return this.stepChangeSubject.asObservable();
  }

  changeStep(toStep: WizardStep): void {
    this.stepChangeSubject.next(toStep);
  }
}
